"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const messages_1 = __importDefault(require("../common/util/constants/messages"));
const styles_1 = require("./styles");
const PhoneNumberLink = ({ phone, intl }) => {
    return (react_1.default.createElement(styles_1.Link, { href: `tel:${phone}`, title: intl.formatMessage(messages_1.default.phoneNumberLinkTitle, {
            phone_number: phone
        }), "data-testid": "PhoneNumberLink" }, phone));
};
exports.default = (0, intl_1.injectIntl)(PhoneNumberLink);
//# sourceMappingURL=PhoneNumberLink.js.map